module.exports = __webpack_public_path__ + "img/calendar2_w.562f004d.svg";